// extracted by mini-css-extract-plugin
export var footer = "_rb-0";
export var inherit = "_rb-1";
export var input = "_rb-2";
export var modalContent = "_rb-3";
export var quillEditor = "_rb-4";
export var subtitle = "_rb-5";